/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbToggleModule,
  NbWindowModule,
} from '@nebular/theme';
import { AffiliateService } from './services/affiliate.service';
import { ReactiveFormsModule, FormGroupDirective, FormsModule } from '@angular/forms';
import { environment } from '../environments/environment';
import { AuthInterceptor } from './pages/shared/auth/auth.interceptor';
import { TogglebuttonComponent } from './components/togglebutton/togglebutton.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { LoaderComponent } from './pages/loader/loader.component';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http,
    './assets/i18n/',
    '.json');
}
@NgModule({
  declarations: [AppComponent, TogglebuttonComponent, LoaderComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbToggleModule,
    ReactiveFormsModule,
    FormsModule,
    ReactiveFormsModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
  ],

  bootstrap: [AppComponent],
  providers: [
    {provide: 'environment', useValue: environment},
    FormGroupDirective,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
  ],

})
export class AppModule {
}
